import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import FriendsWithBenefitsIllustration from "@/assets/friendsWithBenefits/friendsWithBenefits.svg?react";
import { ProductCard } from "@/components/Layout/BaseLayouts/ProductCard/ProductCard";
import { ProductCardFooterItem } from "@/components/Layout/BaseLayouts/ProductCard/ProductCardFooterItem";
import { portalRoutes } from "@/router/routes/portalRoutes";

/**
 * Promotes Friends with Benefits on the Cockpit dashboard. Gated by
 * CockpitDashboard - see there for the visibility rules.
 */
export const FWBCard = () => {
  const { t } = useTranslation("portal");
  const navigate = useNavigate();

  return (
    <ProductCard
      dataTestid="fwb-card"
      header={
        <div className="flex h-full w-full flex-col items-start gap-3 pt-4">
          <FriendsWithBenefitsIllustration className="size-16 shrink-0" />
          <p className="w-full text-headline-md font-semibold leading-sm text-foreground-primary">
            {t("cockpit.dashboard.resources.fwb.title")}
          </p>
          <p className="w-full text-body-lg font-semibold leading-md text-foreground-primary">
            {t("cockpit.dashboard.resources.fwb.text")}
          </p>
        </div>
      }
      footer={
        <ProductCardFooterItem
          variant="button"
          label={t("cockpit.dashboard.resources.fwb.button")}
          onClick={() => navigate(portalRoutes.friendsWithBenefits.base)}
        />
      }
    />
  );
};
